module.exports = __webpack_public_path__ + "static/media/arctic-crowd-source-logo.8aa1d941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/arctic-crowd-source-logo.png
// module id = 2374
// module chunks = 0